import styled from "styled-components";
import {FadeWrapper} from "../../../fade-in-div-on-mount.component";
import {hexToRgba} from "../../../../../themes/hex-to-rgba";

export const MaskFabricDefaultBox = styled(FadeWrapper)`
	width: 100%;
    height: 100%;
    background: linear-gradient(${({theme}) => hexToRgba(theme.colors.backgroundMiddleDark, 1)} 0%, ${({theme}) => hexToRgba(theme.colors.backgroundMiddleDark, 0.7)} 80% , ${({theme}) => hexToRgba(theme.colors.backgroundMiddleDark, 0.8)} 150%);
`;